import React from "react";
import Styles from './styles.module.scss';
import {useSelector} from "react-redux";
import {useLocation, useNavigate} from "react-router-dom";
import {useTranslation} from "react-i18next";
import {toast} from "react-toastify";
import {shortAddress, formatCompact} from "../cabinetShell/config";

import avatarPlaceholder from '../../theme/assets/redesign/avatar_placeholder.webp';
import copyIcon from '../../theme/assets/redesign/copy.svg';
import editIcon from '../../theme/assets/redesign/edit.svg';
import NotificationBell from "../notificationBell";


// Десктоп: колокольчик + кошелёк в правом верхнем углу.
// Мобилка: аватар + ник слева, кошелёк и колокольчик справа.
const CabinetTopBar = () => {
    const navigate = useNavigate();
    const {pathname} = useLocation();
    // на десктопе топбар есть только в макете CFP; на остальных страницах его место занимает контент
    const desktopVisible = pathname === '/matrix';
    const {t} = useTranslation();
    const userData = useSelector(store => store.cabinet.userData);

    // адреса кошелька пока нет в API — показываем «—»
    const wallet = userData?.user?.wallet || userData?.wallet || '';
    const avatar = userData?.user?.avatar || avatarPlaceholder;
    const tokens = Number(userData?.user?.tokens) || 0;
    const usdt = tokens * (Number(userData?.token_rate) || 0);

    const copyHandler = () => {
        if (!wallet) return;
        navigator.clipboard.writeText(wallet);
        toast(t('Скопировано'));
    };

    return (
        <header className={`${Styles.container} ${desktopVisible ? '' : Styles.desktopHidden}`}>
            <div className={Styles.identity} onClick={() => navigate('/settings')}>
                <div className={Styles.avatar}>
                    <img src={avatar} alt={userData?.user?.username || ''}/>
                </div>
                <div className={Styles.name}>
                    <div className={Styles.nameRow}>
                        <span>{userData?.user?.username}</span>
                        <img src={editIcon} alt="edit" width="14" height="14"/>
                    </div>
                    <div className={Styles.caption}>{t('Ваш никнейм')}</div>
                </div>
            </div>

            <div className={Styles.actions}>
                <NotificationBell size="lg" className={Styles.desktopOnly}/>
                {/* мобилка: баланс токенов вместо кошелька (макет Leaderboard 2401:2587) */}
                <div className={`${Styles.balanceChip} ${Styles.mobileOnly}`} onClick={() => navigate('/wallet')}>
                    <div className={Styles.balanceValue}>
                        <span>{formatCompact(tokens)}</span>
                        <span className={Styles.red}>FTF</span>
                        <span className={Styles.muted}>≈</span>
                        <span>{formatCompact(usdt)}</span>
                        <span className={Styles.green}>USDT</span>
                    </div>
                    <div className={Styles.balanceCaption}>{t('Ваш баланс токенов')}</div>
                </div>
                <div className={`${Styles.walletChip} ${Styles.desktopOnly}`} onClick={copyHandler}>
                    <div className={Styles.walletAvatar}>
                        <img src={avatar} alt=""/>
                    </div>
                    <span>{shortAddress(wallet)}</span>
                    <img src={copyIcon} alt="copy" width="18" height="18"/>
                </div>
                <NotificationBell size="sm" className={Styles.mobileOnly}/>
            </div>
        </header>
    );
};

export default CabinetTopBar;
